import { BvTableFieldArray } from 'bootstrap-vue';

// It is global variables initialized on the layout page
export const storeName = window.STORE_NAME;
export const storeCode = window.CURRENT_STORE;
export const locale = window.LOCALE;
export const dataLayer = window.dataLayer
export const ga4Token = window.ga4Token
export const gtag = window.gtag
// Need to trim store and language from base URL because they will be added later as parameters for each API call.
export const baseUrl = window.BASE_URL.replace(`/${storeName}`, "/")
  .replace(`/${locale}`, "/")
  .replace(/[/]+$/, "");

export const fullBaseUrl = `${baseUrl}/${storeName}/${locale}/`;
export const loginUrl = `${fullBaseUrl}account/login`;
export const accessDeniedUrl = `${fullBaseUrl}error/AccessDenied`;

// General variables
export const isoDateFormat = "YYYY-MM-DD";

export const gtagSendToIdQuoteRequest = 'AW-1000776366/EZtQCJKn6aAYEK7Fmt0D';
export const gtagSendToIdContactsRequest = 'AW-1000776366/k7BOCJWn6aAYEK7Fmt0D';
export const gtagSendToIdDownloadsRequest = 'AW-1000776366/yI1ICJin6aAYEK7Fmt0D';
export const gtagSendToIdApplicationRequest = 'AW-1000776366/_5rGCJun6aAYEK7Fmt0D';

// Search
export const pageSizes = [10, 20, 50, 100]
export const defaultPageSize = 50;
export const startPageNumber = 1;
export const ordersStatuses = ["New", "Cancelled", "Processing", "Completed", "Pending"];
export const invoicesStatuses = ["New", "Paid"];
export const paymentsStatuses = ["Paid"];
export const orderDraftType = "orderDraft";
export const sortAscending = "asc";
export const sortDescending = "desc";
export const catalogOrderDraftsCount = 100;

// Grids
export const ordersGridFields = [];
export const usersGridFields = [];
export const invoicesGridFields = [];
export const paymentsGridFields = [];
export const draftsGridFields = [];

// features
export const features = {};
